var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 10.7501V14.2501C13.3346 17.1667 12.168 18.3334 9.2513 18.3334H5.7513C2.83464 18.3334 1.66797 17.1667 1.66797 14.2501V10.7501C1.66797 7.83341 2.83464 6.66675 5.7513 6.66675H9.2513C12.168 6.66675 13.3346 7.83341 13.3346 10.7501Z",
    stroke: "#46515A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 5.75008V9.25008C18.3346 12.1667 17.168 13.3334 14.2513 13.3334H13.3346V10.7501C13.3346 7.83341 12.168 6.66675 9.2513 6.66675H6.66797V5.75008C6.66797 2.83341 7.83464 1.66675 10.7513 1.66675H14.2513C17.168 1.66675 18.3346 2.83341 18.3346 5.75008Z",
    stroke: "#46515A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.a612f14dd9c0e60a0253979b504e10a6.svg";
export { ForwardRef as ReactComponent };